<div class="row g-0 page-header">
  <div class="col d-flex align-items-center">
    <div class="text-body-secondary fw-bold">{{ title ? (title | messageTranslate) : (titleStr ?? '') }}</div>
  </div>
  <div class="col-auto">
    <!--Optional action buttons content-->
    <ng-content></ng-content>
  </div>
</div>

